import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    baseUrl: String,
    persistUrl: String
  }

  navigate(event) {
    const sortValue = event.target.value
    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set("sort", sortValue)

    if (this.hasPersistUrlValue) {
      fetch(this.persistUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ sort: sortValue })
      })
    }

    Turbo.visit(url.toString(), { action: "replace" })
  }
}
